// extracted by mini-css-extract-plugin
export default {"main":"Header_main__Dpgm+","slide-up":"Header_slide-up__wFgFd"};